export const PRESENTATION_FORMAT = "rgba8unorm" as GPUTextureFormat;
export const PICKING_FORMAT = "rg32uint" as GPUTextureFormat;
export const DEPTH_STENCIL_FORMAT = "depth32float" as GPUTextureFormat;
export const COLOR_SPACE = "srgb";

export const BACKGROUND_COLOR = [0.0, 0.0, 0.3, 1.0] as GPUColor;
export const PICKING_COLOR = [0.0, 0.0, 0.0, 0.0] as GPUColor;
export const EMPTY_COLOR = [0.0, 0.0, 0.0, 0.0] as GPUColor;
